export default __webpack_public_path__ + "images/106c2f115aa73d0cdc06477fd10cf443-helicopter1.png";